import angular from 'angular';
import moment from 'moment';
import uiRouter from 'angular-ui-router';
import routing from './licenses.routes';

export class LicensesController {

  constructor($scope, $http, Auth) {
    var vm = this;
    vm.orderBy = "baseboardId";
    vm.reverseSort = false;
    vm.orderByTodo = "baseboardId";
    vm.reverseSortTodo = false;
    vm.duration = 1;
    $scope._ = _;
    $scope.moment = moment;

    $http.get('/api/licenses').then(response => {
      $http.get('/api/users').then(responseUser => {
        vm.licenses = response.data;
        vm.users = responseUser.data;
        vm.fetchLicenses();
        setTimeout(function() {
          $('.selectpicker').selectpicker('refresh');
        }, 10);
      });
    });

    vm.editLicense = function(license) {
      vm.data = angular.copy(license);
      if(!vm.data.UserId) vm.data.UserId = angular.copy(vm.users[0]._id);
      console.log(vm.data)
      setTimeout(function() {
        $('.selectpicker').selectpicker('refresh');
      }, 10);
      $('#addLicense').modal('show')
    }

    /*$scope.$watch('vm.data.user', function(nv) {
      setTimeout(function() {
        $('.selectpicker').selectpicker('refresh');
      }, 10);
    })*/

    vm.addLicense = function(form) {
      if (form.$valid) {
        vm.errors = undefined;
        $scope.clicked = true;
        vm.data.expiryDate = moment().add(vm.duration, "y").format();
        console.log(vm.data);
        $http.patch(`/api/licenses/${vm.data._id}`, vm.data).then(response => {
          $http.get('/api/licenses').then(response => {
            vm.licenses = response.data;
            vm.fetchLicenses();
            $('#addLicense').modal('hide')
            $scope.clicked = false
            vm.data = {}
          })
        }).catch(err => {
          console.log(err)
          vm.errors = { errorTitle: 'Erreur', errorMessage: err.data.message }
          $scope.clicked = false
        })
      }
    }

    /*vm.availablesLicenses = function() {
      return _([])
      .merge(
        _(vm.licenses).reject('UserId').value(),
        _(vm.licenses).filter(function(l) {
          return (!l.expiryDate || (moment(l.expiryDate).format('YYYY-MM-DD') < moment(moment().endOf('day')).format('YYYY-MM-DD')));
        })
        .value())
      .value()
    }

    vm.availablesLicensesActives = function() {
      return _(vm.licenses).filter('UserId').filter((l) => { return moment(l.expiryDate).format('YYYY-MM-DD') > moment(moment().endOf('day')).format('YYYY-MM-DD'); }).value()
    }*/

    vm.fetchLicenses = function(){
      vm.availablesLicenses = _([])
      .merge(
        _(vm.licenses).reject('UserId').value(),
        _(vm.licenses).filter(function(l) {
          return (!l.expiryDate || (moment(l.expiryDate).format('YYYY-MM-DD') < moment().format('YYYY-MM-DD')));
        })
        .value())
      .value()
      vm.activesLicenses = _(vm.licenses).filter('UserId').filter((l) => {
       return moment(l.expiryDate).format('YYYY-MM-DD') >= moment().format('YYYY-MM-DD'); }
       ).value()

    }
  }
}

export default angular.module('bfastCaptureManagerApp.licenses', [uiRouter])
  .config(routing)
  .component('licenses', {
    template: require('./licenses.html'),
    controller: LicensesController,
    controllerAs: 'vm'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/licenses/licenses.component.js